<script>
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";

export default {
    name: "widget-hidden-icon",
    components: {VTooltipWrapper},
    props: {
        primary: Boolean
    },
    computed: {
        tHidden() {
            return Lang.langGet('This widget is hidden.')
        }
    }
}
</script>

<template>
    <v-btn :color="primary ? 'primary' : null" small icon aria-label="hidden">
        <v-tooltip-wrapper :open-delay="350">
            <template #activator="{ on, attrs }">
                <div v-bind="{...$attrs, ...attrs}"
                     v-on="{...$listeners, ...on}">
                    <v-icon>fa-regular fa-eye-slash</v-icon>
                </div>
            </template>
            <div class="icon-in-tooltip-container">
                {{ tHidden }}
            </div>
        </v-tooltip-wrapper>
    </v-btn>
</template>

<style scoped>
    .v-btn {
        cursor: default !important;
    }
</style>
